export default __webpack_public_path__ + "images/logoDigitalTrends.bedae17feb86622c9855468cf85afcec.svg"